import React from "react";
import { Box, Typography } from "@mui/material";
import { InfoTooltip } from "components/info-tooltip";
import { FieldLabelProps } from "./types";

export const FieldLabel: React.FC<FieldLabelProps> = ({
  children,
  required,
  tooltip,
}) => (
  <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: "6px" }}>
    <Typography
      component="div"
      sx={{
        fontSize: "11px",
        fontWeight: 600,
        color: "#475467",
        textTransform: "uppercase",
        letterSpacing: "0.04em",
        lineHeight: 1.2,
        mt: "2px",
      }}
    >
      {children}
      {required && <span style={{ color: "red" }}> *</span>}
    </Typography>
    {tooltip && <InfoTooltip tooltip={tooltip} />}
  </Box>
);
